export function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 56 32" aria-hidden="true">
      <path d="M3 26C15 26 15 5 25 5c8 0 8 22 17 22 5 0 7-5 11-12" />
      <path d="M8 23c8 0 13-12 20-12 8 0 11 12 23 12" />
      <path d="M17 27c8 0 14-24 24-24" />
    </svg>
  );
}

export function BotIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6.5" width="16" height="13" rx="4" />
      <path d="M12 3v3.5M8.5 12h.01M15.5 12h.01M9 16h6" />
    </svg>
  );
}

export function SendIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m21 3-7.6 18-3.1-7.3L3 10.6 21 3Z" />
      <path d="m10.3 13.7 4.4-4.4" />
    </svg>
  );
}

export function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m5 12.5 4.2 4.2L19.5 6.5" />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5.5 20c.5-4.2 2.7-6.3 6.5-6.3s6 2.1 6.5 6.3" />
    </svg>
  );
}
